
import { useEffect, useState } from "react";
import Page from "../../Page";
import LearningPathReportHomeDetailSection from "./LearningPathReportHomeDetailSection";
import CONFIG from "../../../utils/config";


export const LearningPathOfficeDetailMobilePage = () => {
   
    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <>
            <LearningPathReportHomeDetailSection
                isMobile={true}
            />
        </>
    )
}

export default LearningPathOfficeDetailMobilePage;